import { requestApi } from "../../utils/requestApi";
import { POST } from "../../types/httpMethod";
import { ChartQuestionAnswersResponseType } from "../../types/chartQuestionAnswersInfoType";
import { SpecialChartResponseType } from "../../types/specialChartType";
import { CSIData } from "../../types/csi";
import { FilterStatus } from "../../types/filterStatusValue";

export const getChartData = async (
  surveyId: string,
  from?: string,
  to?: string,
  state: string = FilterStatus.ALL,
): Promise<ChartQuestionAnswersResponseType> => {
  return await requestApi(POST, "/chart/question/answers-info", { from, to, state }, false, false, {}, { surveyId });
};

export const getNPSData = async (surveyId: string, questionId: string, from?: string, to?: string, state?: string) => {
  return await requestApi(POST, `/chart/${surveyId}/question/${questionId}/nps`, { from, to, state }, false, false);
};

export const getSpecialChartData = async (
  surveyId: string,
  questionId: string,
  from?: string,
  to?: string,
  state?: string,
): Promise<SpecialChartResponseType> => {
  return await requestApi(POST, `chart/${surveyId}/question/${questionId}/ranging`, { from, to, state });
};

export const getCSIData = async (
  surveyId: string,
  questionId: string,
  from?: string,
  to?: string,
  state?: string,
): Promise<CSIData> => {
  return await requestApi(POST, `/chart/${surveyId}/question/${questionId}/csi`, { from, to, state }, false, false);
};

export const getSurveyReportPdf = async (surveyId: string) => {
  return await requestApi(POST, `/surveys/${surveyId}/report/pdf`, {}, true, false);
};
